"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderedListContext = void 0;
const react_1 = require("react");
const initialState = {
    variant: 'ordered-list',
    minLevel: 3,
    maxLevel: 9,
    defaultOptions: [[]],
    symbols: [],
    defaultRegex: [''],
    regexOptions: [],
    selectedValues: [''],
    acrossPages: false,
    continueAcrossPagesEditable: true,
    labels: {
        modalTitle: 'Ordered List',
        continueFromPrevious: 'Continue from previous',
        startFrom: 'Start from',
        setNewListStyle: 'Set new list style',
        listSpacing: 'List spacing',
        none: 'None',
        back: 'Back',
        levelTitle: 'Level',
        addLevel: 'Add New Level +',
        removeLevel: 'Remove',
        continueAcrossPages: 'Continue Number across Pages',
        save: 'Save',
        cancel: 'Cancel',
        customBulletModalTitle: 'Bullet',
        regexPlaceholder: 'Add prefix (optional)',
        separator: 'Separator',
        tooltipOrderedRegex: 'Customize your list by adding text or symbols before your content',
    },
    listStyles: {
        '6': {
            mode: 'd',
            symbols: [
                'numbers',
                'letters',
                'roman-numbers-lower',
                'numbers',
                'letters',
                'roman-numbers-lower',
                'numbers',
                'letters',
                'roman-numbers-lower',
            ],
            pattern: [],
        },
        '7': {
            mode: 'd',
            symbols: [
                'numbers',
                'numbers',
                'numbers',
                'numbers',
                'numbers',
                'numbers',
                'numbers',
                'numbers',
                'numbers',
            ],
            pattern: [
                '^#^t',
                '^1.^#^t',
                '^1.^2.^#^t',
                '^1.^2.^3.^#^t',
                '^1.^2.^3.^4.^#^t',
                '^1.^2.^3.^4.^5.^#^t',
                '^1.^2.^3.^4.^5.^6.^#^t',
                '^1.^2.^3.^4.^5.^6.^7.^#^t',
                '^1.^2.^3.^4.^5.^6.^7.^8.^#^t',
            ],
        },
        '8': {
            mode: 'd',
            symbols: [
                'roman-numbers',
                'capital-letters',
                'numbers',
                'roman-numbers',
                'capital-letters',
                'numbers',
                'roman-numbers',
                'capital-letters',
                'numbers',
            ],
            pattern: [],
        },
        '9': {
            mode: 'd',
            symbols: [
                'capital-letters',
                'letters',
                'roman-numbers-lower',
                'capital-letters',
                'letters',
                'roman-numbers-lower',
                'capital-letters',
                'letters',
                'roman-numbers-lower',
            ],
            pattern: [],
        },
        '10': {
            mode: 'd',
            symbols: [
                'numbers-with-two-digits',
                'letters',
                'roman-numbers-lower',
                'numbers-with-two-digits',
                'letters',
                'roman-numbers-lower',
                'numbers-with-two-digits',
                'letters',
                'roman-numbers-lower',
            ],
            pattern: [],
        },
    },
    orderedStyle: 0,
    orderedRegex: '',
    orderedNumberingStyle: 'numbers',
    orderedStart: 0,
    orderedWidth: 0,
    maxOrderedWidth: 200,
    isContinueFromPrevious: true,
    isAdvancedOrderedStyleEnable: false,
    isOrderedStyleEditable: false,
    advancedOrderedStyleFeatureFlag: true,
    regexButtons: [],
    setOrderedStyle: () => console.log('setOrderedStyle'),
    toggleAdvancedOrderedStyle: () => console.log('toggleAdvancedOrderedStyle'),
    setOrderedNumberingStyle: () => console.log('setOrderedNumberingStyle'),
    setOrderedRegex: () => console.log('setOrderedRegex'),
    setContinueFromPrevious: () => console.log('setContinueFromPrevious'),
    setOrderedStart: () => console.log('setOrderedStart'),
    setOrderedWidth: () => console.log('setOrderedWidth'),
    onSave: (values, { acrossPages, regex }) => console.log(values, acrossPages, regex),
    onCancel: () => console.log('cancel'),
};
exports.OrderedListContext = (0, react_1.createContext)(initialState);
//# sourceMappingURL=OrderedListContext.js.map